// Style
import { ROUTE_TODAY } from 'components/common/helpers/Paths'
import './Terms.scss'

// React and Third Party
import { useState } from 'react'
import { Alert, Col, Container, Button, Row } from 'react-bootstrap'
import { useHistory } from 'react-router-dom'

import { navigateTo } from 'components/common/navigation'

// Components

/**
 * Core AI Terms of Service Component
 * @returns {JSX.Element} The Terms Component
 */
export default function Terms({ setAccepted }) {
  const history = useHistory()
  const [error, setError] = useState(null)
  const [loading, setLoading] = useState(false)

  /**
   * Handle accepting the terms
   */
  const handleAccept = async () => {
    // Set the loading state
    setLoading(true)
    setError(null)

    // Update the user's acceptance flag
    const result = await setAccepted(true)
    const message = result.error || result.detail

    // Update the loading state
    setLoading(false)

    // If we have an error, set it
    if (message) return setError(message)

    setAccepted(true)
  }

  return (
    <Container className='container-termsofservice'>
      <h1 className='title green'>
        Usage Guidelines for Mental Health Assistant
      </h1>
      <p>
        At Remble, protecting your trust and privacy is our top priority. You
        can trust that any information you enter into our system will remain
        completely anonymous and secure. We utilize the latest security and
        privacy measures to safeguard your data and your personal information is
        never shared or sold. Your trust is essential to us, and we are fully
        committed to providing you with a safe and trustworthy experience.
      </p>
      <p>
        Our goal is to ensure that you use the Mental Health Assistant
        responsibly and thoughtfully. Please follow these guidelines:
      </p>
      <ul>
        <li>
          <strong>Use the Assistant thoughtfully:</strong> The information
          provided is based on data and algorithms, and may not always be
          accurate or up-to-date. It is important to approach the information
          with a critical mindset and evaluate its reliability. Please do not
          include any sensitive personal information or credit card numbers in
          your chat.
        </li>
        <li>
          <strong>Verify the results of your queries:</strong> Although the
          Assistant strives to provide accurate information, it is always a good
          idea to double-check the results of your queries, especially when it
          comes to phone numbers, URLs, and text numbers, as these often change.
        </li>
        <li>
          <strong>Consult reliable sources for important decisions:</strong> The
          Mental Health Assistant is not a substitute for face to face
          psychotherapy. It is not intended to be used to assess health
          conditions or substitute for professional medical advice. Do not rely
          solely on information provided by the Assistant, particularly when it
          comes to important life decisions such as changes in your level of
          physical activity. We recommend that you consult with a reliable
          authority, such as a doctor or an informed professional, before making
          any significant decisions.
        </li>
        <li>
          <strong>Be responsible:</strong> Do not use the Assistant for any
          malicious or illegal purposes.
        </li>
      </ul>

      {error && (
        <Alert variant='danger' onClose={() => setError('')} dismissible>
          {error}
        </Alert>
      )}

      <Row className='my-4'>
        <Col
          xs={{ span: 12, order: 2 }}
          sm={{ span: 3, order: 1 }}
          className='text-center'
        >
          <Button
            variant='link exit-link'
            onClick={_ => navigateTo(ROUTE_TODAY, history)}
            disabled={loading}
          >
            Decline
          </Button>
        </Col>
        <Col
          xs={{ span: 12, order: 1 }}
          sm={{ span: 9, order: 2 }}
          className='text-center'
        >
          <Button
            variant='primary'
            size='lg'
            className='w-100'
            onClick={_ => handleAccept()}
            disabled={loading}
          >
            {loading ? 'Saving...' : 'Accept and Continue'}
          </Button>
        </Col>
      </Row>
    </Container>
  )
}
